import {
  SEGMENT_OPTIONS,
  DEALERSTATE_OPTIONS,
  DEALERRATING_OPTIONS,
  FLAG_OPTIONS,
} from './longChannelVocabularies';
import { atDialect } from '../../../Components/engine/dialect';

/**
 * Layout descriptor for the long channel's filter panel, in the field shape the render engine
 * reads. Checked into the frontend for now; it moves server-side with the other descriptors.
 *
 * `key` is the filter parameter the page sends. A leading `$` reads the key out of the row's
 * Attributes document rather than a projected column; `city` has none because it is a real column.
 * `operator` is what the list's filter list applies to the key.
 *
 * A field whose options are a closed set declares them inline. A field whose options are whatever
 * the data holds carries `optionsUrl` and `parameters` instead, and the engine fetches them;
 * `contextParameters` names the values the page supplies at runtime.
 */

export const LONGCHANNEL_FILTERS_GROUP = 'DEALERS';
export const LONGCHANNEL_FILTERS_SURFACE = 'filters';

export const LONGCHANNEL_FILTERS_LAYOUT = atDialect([
  {
    key: '$SEGMENT',
    type: 'select',
    label: 'SEGMENT',
    multiple: true,
    size: { xs: 12, md: 6 },
    options: SEGMENT_OPTIONS,
  },
  {
    key: '$DEALERSTATE',
    type: 'select',
    label: 'STATUS',
    multiple: true,
    size: { xs: 12, md: 6 },
    options: DEALERSTATE_OPTIONS,
  },
  {
    key: '$DEALERRATING',
    type: 'select',
    label: 'DEALERRATING',
    multiple: true,
    size: { xs: 12, md: 6 },
    options: DEALERRATING_OPTIONS,
  },
  {
    key: '$BUSINESSPACKAGE',
    type: 'text',
    label: 'BUSINESSPACKAGE',
    size: { xs: 12, md: 6 },
  },
  {
    key: '$HASNATIONALAGREEMENT',
    type: 'select',
    label: 'HASNATIONALAGREEMENT',
    size: { xs: 12, md: 6 },
    operator: 'eq',
    // The empty value applies no filter.
    options: [{ value: '', label: 'ALL' }, ...FLAG_OPTIONS],
  },
  {
    key: '$NATIONALAGREEMENT',
    type: 'text',
    label: 'NATIONALAGREEMENT',
    size: { xs: 12, md: 6 },
  },
  {
    key: 'city',
    type: 'select',
    searchable: true,
    label: 'CITY',
    optionsUrl: 'CITY_BY_BRANCH',
    contextParameters: ['BranchId'],
    size: { xs: 12, md: 6 },
  },
]);
